import { computed, inject, Injectable, signal } from '@angular/core';
import type { User } from '@/core/user/user.model';
import type { AuthSuccess } from '@/core/user/auth.model';
import { TokenStorageService } from '@/core/storage/token-storage.service';
import { userFromIdToken } from '@/core/user/jwt-user';

@Injectable({
  providedIn: 'root',
})
export class AuthStore {
  private tokenStorage = inject(TokenStorageService);

  private _currentUser = signal<User | undefined>(undefined);

  public currentUser = this._currentUser.asReadonly();
  public isAuthenticated = computed(() => this._currentUser() !== undefined);

  constructor() {
    this.restoreUser();
  }

  storeAuthResult(result: AuthSuccess): void {
    this.tokenStorage.setIdToken(result.idToken);
    this.tokenStorage.setAccessToken(result.accessToken);
    this.tokenStorage.setRefreshToken(result.refreshToken);
    this.restoreUser();
  }

  logout(): void {
    this.tokenStorage.clearAll();
    this._currentUser.set(undefined);
  }

  private restoreUser(): void {
    const token = this.tokenStorage.getIdToken();
    if (token === null || token === '') return undefined;

    const user = userFromIdToken(token);
    if (!user) {
      this.tokenStorage.clearAll();
      return undefined;
    }

    this._currentUser.set(user);
  }
}
